export default {
    name: "SpotFiftyFifty",
    setup(){
        
    }
}